// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__HBRNw","inputWrap":"styles_inputWrap__jFAS0","input":"styles_input__2flpU"};